module.exports = __webpack_public_path__ + "img/icon-buy-token-white.7749fb50.svg";